import React from "react";

const AnalyticsPagination = ({
    currentPage,
    totalPages,
    totalCount,
    pageSize,
    onPageSizeChange,
    onPageChange,
}) => {
    const start = totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1;
    const end = Math.min(currentPage * pageSize, totalCount);
    // Build page number list with ellipsis
    const getPages = () => {
        if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
        const pages = [];
        if (currentPage <= 4) {
            pages.push(1, 2, 3, 4, 5, "…", totalPages);
        } else if (currentPage >= totalPages - 3) {
            pages.push(1, "…", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
        } else {
            pages.push(1, "…", currentPage - 1, currentPage, currentPage + 1, "…", totalPages);
        }
        return pages;
    };

    return (
        <div className="flex flex-col items-center justify-between gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3 md:flex-row">
            <p className="text-[12px] text-gray-400">
                Showing{" "}
                <span className="font-medium text-gray-600">{start}</span>
                {" – "}
                <span className="font-medium text-gray-600">{end}</span>
                {" of "}
                <span className="font-medium text-gray-600">{totalCount}</span>
                {" visitors"}
            </p>

            <div className="flex items-center gap-1.5">
                <button
                    disabled={currentPage === 1}
                    onClick={() => onPageChange(currentPage - 1)}
                    className="flex items-center gap-1 rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-[12px] font-medium text-gray-600 transition hover:border-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
                >
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <polyline points="15 18 9 12 15 6"/>
                    </svg>
                    Previous
                </button>

                <div className="flex items-center gap-1">
                    {getPages().map((page, idx) =>
                        page === "…" ? (
                            <span key={`ellipsis-${idx}`} className="w-7 text-center text-[12px] text-gray-400">
                                …
                            </span>
                        ) : (
                            <button
                                key={page}
                                onClick={() => onPageChange(page)}
                                className={`flex h-7 w-7 items-center justify-center rounded-lg text-[12px] font-medium transition ${
                                    page === currentPage
                                        ? "bg-indigo-50 text-indigo-700 border border-indigo-200"
                                        : "text-gray-500 hover:bg-gray-100 border border-transparent"
                                }`}
                            >
                                {page}
                            </button>
                        )
                    )}
                </div>

                <button
                    disabled={currentPage === totalPages}
                    onClick={() => onPageChange(currentPage + 1)}
                    className="flex items-center gap-1 rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-[12px] font-medium text-gray-600 transition hover:border-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
                >
                    Next
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <polyline points="9 18 15 12 9 6"/>
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default AnalyticsPagination;